import {shopModule} from '../module.js';

shopModule.directive('nsCreditCardFormatter', function() {
    return {
        require: 'ngModel',
        link: function(scope, ele, attr) {
            scope.$watch('sections.payment.adding', function(newValue) {
                if (newValue) {
                    let model = scope.$eval(attr.ngModel.substr(0, attr.ngModel.lastIndexOf(".")));
                    let paymentDescription = model.paymentTypeDescription;

                    // scope.mask is set in the form element set as a directive using ui-mask="{{mask}}"
                    switch (paymentDescription) {
                        case "Visa":
                        case "MasterCard":
                        case "Discover":
                            scope.mask = '9999-9999-9999-9999';
                            break;
                        case "American Express":
                            scope.mask = '9999-999999-99999';
                            break;
                        default:
                            scope.mask = '9999-9999-9999-9999';
                    }
                }
            });

        }
    }
});
